/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, reason: NonNullable<unknown> }} Idea_Attach_Upload_FailedInputs */

const en_idea_attach_upload_failed = /** @type {(inputs: Idea_Attach_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upload of ${i?.name} failed: ${i?.reason}. The plan was created — you can continue without it.`)
};

const id_idea_attach_upload_failed = /** @type {(inputs: Idea_Attach_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upload ${i?.name} gagal: ${i?.reason}. Plan tetap dibuat — kamu bisa lanjut tanpa file ini.`)
};

/**
* | output |
* | --- |
* | "Upload of {name} failed: {reason}. The plan was created — you can continue without it." |
*
* @param {Idea_Attach_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_attach_upload_failed = /** @type {((inputs: Idea_Attach_Upload_FailedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_Attach_Upload_FailedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_attach_upload_failed(inputs)
	return en_idea_attach_upload_failed(inputs)
});